import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Validator } from 'projects/core/src/lib/helpers/validator';

@Component({
  selector: 'app-detail-view',
  templateUrl: './detail-view.component.html',
  styleUrls: ['./detail-view.component.scss']
})
export class DetailViewComponent implements OnInit {

  @Input() loading = false;
  @Input() title: string | Array<string> = null;
  @Input() messages: Array<any> = [];
  @Input() close = true;
  @Output() closed = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closed.emit();
  }

  get titleIsString(): boolean {
    return Validator.isString(this.title);
  }

  get titleIsArray(): boolean {
    return Validator.isArray(this.title, 2);
  }

}
